import React, {Component} from 'react';
import {
    AJAX,
    showPreloader,
    hidePreloader,
    close_popup,
    compressImage,
    addStepLog,
    setUrlSinglePageApp
} from "../functions";
import {Redirect} from "react-router-dom";
import {showProgressBarPopup} from "../popups/ProgressBarPopup";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import PreviewPhoto from "../common/PreviewPhoto";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {withRouter} from "react-router";

class CheckFuelPage extends Component {
    constructor(props) {
        super(props);
        this.sendPhoto = this.sendPhoto.bind(this);
        this.getPhoto = this.getPhoto.bind(this);
        this.onClickAnswer = this.onClickAnswer.bind(this);
        this.allowNextButton = this.allowNextButton.bind(this);
        this.state = {file_url: null, answer: null, allowContinue: false, uploadPercent: 0};
        if (this.props.booking_state.fuel_begin) {
            this.state.answer = this.props.booking_state.fuel_begin;
            this.allowNextButton(this.state.answer, true);
        }

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    allowNextButton(answ, intConstructor) {
        let allow = false;
        switch (answ) {
            case 'yes':
                allow = true;
                break;
            case 'no':
                if (this.getPhoto()) {
                    allow = true;
                }
        }
        if (intConstructor) this.state.allowContinue = allow;
        else this.setState({allowContinue: allow});
    }

    getPhoto() {
        if (this.props.booking_state.hasOwnProperty('files')
            && this.props.booking_state.files.hasOwnProperty('check_fuel')
            && this.props.booking_state.files.check_fuel.hasOwnProperty('dashboard')
        )
            return this.props.booking_state.files.check_fuel.dashboard;
        else
            return null;
    }

    redirectToThankYou() {
        let t = this;

        if (!t.state.allowContinue) {
            return false;
        }

        let params = {
            session_key: t.props.session_key,
            global_operation: t.props.global_operation,
            answer_key: 'fuel_begin',
            answer_value: t.state.answer,
            action: 'api/booking/send_answer'
        };

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length) {
                    t.props.handleSetBookingState(resp.data.booking_state);
                    // this.handleSetPage({name: 'thank_you', params: {use: 'begin'}});
                    t.setState({redirect: true});
                } else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    onClickAnswer(val) {
        addStepLog('Press button '+val+' on Check fuel Page');
        this.allowNextButton(val);
        this.setState({answer: val})
    }

    sendPhoto(e) {
        addStepLog('Send photo to answer NO on Check fuel Page');

        let t = this;
        let file = e.target.files[0];
        if (!file)
            return false;

        compressImage(
            file,
            (modifiedFile) => {
                let params = {
                    session_key: t.props.session_key,
                    resno: t.props.client_data.resno,
                    operation: 'check_fuel',
                    global_operation: t.props.global_operation,
                    step: 'dashboard',
                    files: {
                        photo: modifiedFile
                    },
                    action: 'api/booking/send_photo'
                };

                AJAX(bm_ajax_url, 'POST', params, {
                    response_json: true,
                    func_waiting: ()=>showProgressBarPopup(t.state.uploadPercent),
                    func_callback: function (resp) {
                        close_popup();
                        if (resp.success === 1 && Object.keys(resp.data).length) {
                            // show_success_popup('Photo is successfully loaded');
                            // setTimeout(() => t.redirectToThankYou(), 3000);
                            t.props.handleSetBookingState(resp.data.booking_state);
                            t.setState({uploadPercent: 0, allowContinue: true});
                        } else {
                            if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                                showPopupWithGoBack(resp.errors.main);
                            }
                        }
                    },
                    func_error: function (resp) {
                        close_popup();
                        showPopupWithGoBack(resp.message);
                    },
                    func_progress: function (evt) {
                        if (evt.lengthComputable) {
                            let percentComplete = Math.round(evt.loaded / evt.total * 100);
                            t.setState({uploadPercent: percentComplete}, () => showProgressBarPopup(t.state.uploadPercent));

                        }
                    }
                });
            }
        )
    }

    render() {
        if (this.state.redirect){
            addStepLog('Thank you Page');
            return  <Redirect push to='/thank_you' />;
        }

        return (<>
            <RedirectOnlyHome />
            <div className={'value-space'}>
                <div className="row">
                    <div className="offset-2 col-8">
                        <h1 className="my-4">Is the vehicle full of fuel?</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8 text-center">
                        <div className="mb-3">
                            <button type="button"
                                    className={'base-input white-green mb-4' + (this.state.answer === 'yes' ? ' selected' : '')}
                                    onClick={()=>this.onClickAnswer('yes')}>
                                YES
                            </button>
                            <button type="button"
                                    className={'base-input white-red mb-4' + (this.state.answer === 'no' ? ' selected' : '')}
                                    onClick={()=>this.onClickAnswer('no')}>
                                NO
                            </button>
                        </div>
                    </div>
                </div>
                {
                    this.state.answer === 'no' ? (<>
                        <div className="row">
                            <div className="col-12 mx-4 pl-4 pr-5 text-left">
                                <div className="photo-preview">

                                    {/*{this.getPhoto() ? (<img src={this.getPhoto()} />) : (<div className="no-photo"/>) } Photo of gauge*/}
                                    {this.getPhoto() ? (<PreviewPhoto src={this.getPhoto()} />) : (<div className="no-photo"/>) } Photo of gauge
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="offset-2 col-8 text-center">
                                <div className="form-group mb-4">
                                    <input type="file" id="photo" accept="image/*" capture="camera"
                                           className="mb-4" name="photo"
                                           onChange={this.sendPhoto.bind(this)}
                                    />
                                    <label htmlFor="photo"
                                           className={"base-input"}>{!this.getPhoto() ? "TAKE PHOTO" : "REPLACE PHOTO"}</label>
                                </div>
                            </div>
                        </div>
                        </>) : ('')
                }
                {
                    this.state.allowContinue ? (
                        <div className="row">
                            <div className="offset-2 col-8 text-center">
                                <div
                                    className={"go-btn go-next mx-auto" + (!this.state.allowContinue ? ' disabled' : '')}
                                    onClick={() => this.redirectToThankYou()}
                                />
                            </div>
                        </div>
                    ) : ('')
                }
                {/*{
                            this.getPhoto() === null ? (
                                <div>
                                    <h2 className={this.state.send_photo ? '' : 'lightgray'}>Take photo of gauge</h2>
                                    <div className="form-group mb-4">
                                        <input type="file" id="photo" accept="image/*" capture="camera" className="mb-4" name="photo" onChange={this.sendPhoto.bind(this)} disabled={!this.state.send_photo} />
                                        <label htmlFor="photo" className={this.state.send_photo ? 'base-input' : 'base-input disabled'}>TAKE PHOTO</label>
                                    </div>
                                </div>
                            ) : (
                                <div className="photo-preview">
                                    {this.getPhoto() ? (<img src={this.getPhoto()} />) : (<div className="no-photo"/>) } Photo of gauge
                                </div>
                            )
                        }*/}
            </div>
        </>);
    }
}

const CheckFuelPageR = withRouter(CheckFuelPage);
export default CheckFuelPageR;
